<div
    class="form-group container"
    id="location-detail-detail-component"
    *ngIf="location"
>
    <form #updateLocationForm="ngForm">
        <div class="row">
            <div>
                <h1 *ngIf="type === 'update'">
                    <i class="fa fa-industry fa-pre" aria-hidden="true"></i>
                    {{ locationName }}
                </h1>
                <h1 *ngIf="type === 'create'">
                    <i class="fa fa-industry fa-pre" aria-hidden="true"></i>
                    {{ 'locations.create.header' | translate }}
                </h1>
                <h2 *ngIf="type === 'createInModal'" style="margin-left: 30px">
                    <i class="fa fa-industry fa-pre" aria-hidden="true"></i>
                    {{ 'locations.create.header' | translate }}
                </h2>
                <div style="margin-top:30px;">
                    <div>
                        <div class="plt-display-row col-md-12 plt-b-spaced">
                            <h3 style="margin-left: 30px">Requis</h3>
                        </div>
                        <div class="plt-display-row col-md-12 plt-b-spaced">
                            <div class="col-md-6">
                                <div class="col-md-3" style="margin-top:15px;">
                                    <label for="name" class="required">{{
                                        'locations.name' | translate
                                    }}</label>
                                </div>
                                <div class="col-md-9">
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="name"
                                        required
                                        #name="ngModel"
                                        name="name"
                                        [(ngModel)]="location.name"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="plt-display-row col-md-12 plt-b-spaced">
                            <div class="col-md-6">
                                <div class="col-md-3" style="margin-top:15px;">
                                    <label for="address1" class="required">{{
                                        'locations.detail.address1' | translate
                                    }}</label>
                                </div>
                                <div class="col-md-9">
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="address1"
                                        #name="ngModel"
                                        name="address1"
                                        [(ngModel)]="location.address1"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="plt-display-row col-md-12 plt-b-spaced">
                            <div class="col-md-6">
                                <div
                                    class="col-md-3"
                                    style="margin-top:15px;"
                                ></div>
                                <div class="col-md-9">
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="address2"
                                        #name="ngModel"
                                        name="address2"
                                        [(ngModel)]="location.address2"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="plt-display-row col-md-12 plt-b-spaced">
                            <div class="col-md-6">
                                <div class="col-md-3" style="margin-top:15px;">
                                    <label for="zipCode">{{
                                        'locations.zipCode' | translate
                                    }}</label>
                                </div>
                                <div class="col-md-9">
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="zipCode"
                                        #name="ngModel"
                                        name="zipCode"
                                        [(ngModel)]="location.zipCode"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="plt-display-row col-md-12 plt-b-spaced">
                            <div class="col-md-6">
                                <div class="col-md-3" style="margin-top:15px;">
                                    <label for="city" class="required">{{
                                        'locations.city' | translate
                                    }}</label>
                                </div>
                                <div class="col-md-9">
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="city"
                                        #name="ngModel"
                                        name="city"
                                        [(ngModel)]="location.city"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="margin:0 30px 15px;">
                <button
                    style="margin-top: 20px;"
                    class="btn btn-primary"
                    type="submit"
                    [disabled]="!updateLocationForm.valid"
                    name="submit"
                    (click)="save()"
                >
                    Sauvegarder
                </button>
                <button
                    style="margin-top: 20px;"
                    *ngIf="type === 'update'"
                    class="btn btn-default"
                    (click)="removeLocation(location)"
                >
                    Supprimer
                </button>
                <a uiSref="locations" uiSrefActive="active">
                    <button style="margin-top: 20px;" class="btn btn-default">
                        Retour
                    </button>
                </a>
            </div>
        </div>
    </form>

    <div *ngIf="location.id">
        <location-rooms [location]="location"></location-rooms>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/directory/location/detail/detail.component.html